/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui core components
import { List, ListItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { YMInitializer } from 'react-yandex-metrika';
import Typography from '@material-ui/core/Typography';

import styles from "assets/jss/material-kit-react/components/footerStyle.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <div className={classes.container}>
      <GridContainer maxWidth="sm" justify="center" >
        <GridItem xs={12} sm={12} md={3}>
          <div >
            <ul className={classes.footerList + " " + classes.right}>
              <li>
                <a
                  href="http://tpan.ir"
                  className={classes.footerItem}
                  target="_blank"
                >
                  نمایشگاه مجازی ترنج
                </a>
              </li>
              <li>
                <a
                  href="/AboutUs"
                  className={classes.footerItem}
                  target="_Self"
                >
                  درباره ما
                </a>
              </li>
              <li>
                <a
                  href="/ContactUs"
                  className={classes.footerItem}
                  target="_Self"
                >
                  تماس با ما
                </a>
              </li>
            </ul>
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={4} className={classes.right} >
          <Typography variant="caption" gutterBottom >
            آدرس: مازندران، قائمشهر، کیلومتر ۲ جاده قائمشهر به بابل، روبروی دانشکده علوم انسانی دانشگاه آزاد اسلامی قائمشهر
            <br />
            شماره تماس: 09999921487
            <br />
            ایمیل: 	info@sharifcamp.ir
          </Typography>
        </GridItem>
        <GridItem xs={12} sm={12} md={5}>
          <div>
          </div>
        </GridItem>
        <GridItem>
          <div className={classes.footerList + " " + classes.center + " " + classes.ltr + " " + classes.copyright}>
            &copy; {1900 + new Date().getYear()} SHARIFCAMP ALL RIGHTS RESERVED</div>
          <YMInitializer accounts={[69578758]} options={{ clickmap: true, trackLinks: true, accurateTrackBounce: true, webvisor: true }} />

        </GridItem>
      </GridContainer>

    </div>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool
};
